import { Grid } from '@material-ui/core';
import React from 'react';
import { useIntl } from 'react-intl';
import { useDispatch, useSelector } from 'react-redux';
import { sanlamYellow } from 'Material-UI/colors';

import { MediumSectionHeader } from 'components/Typography';
import {
  StyledGrid,
  StyledLink,
  StyledTypography,
} from 'containers/SiteMapPage/styles';
import { pushTo } from 'helpers/routes';
import { getLocaleSelector } from 'store/LanguageProvider/selectors';

const FaqItem = ({ title, data }: { title: any; data: any[] }) => {
  const intl = useIntl();
  const dispatch = useDispatch();
  const language = useSelector(getLocaleSelector);

  return (
    <Grid item xs={12} sm={6} md={4} lg={3}>
      <StyledGrid>
        <MediumSectionHeader color={sanlamYellow}>
          {intl.formatMessage({ id: title.id })}
        </MediumSectionHeader>
        <Grid>
          {data.map((item) => {
            return (
              <StyledLink
                key={item.title.id}
                href={item.link[language]}
                target="_blank"
                onClick={() => {
                  const { payload, link, isExternalLink } = item;
                  if (!isExternalLink) {
                    if (payload) {
                      dispatch(payload);
                    }
                    pushTo(link);
                  }
                }}
              >
                <StyledTypography variant="body1">
                  {intl.formatMessage({ id: item.title.id })}
                </StyledTypography>
              </StyledLink>
            );
          })}
        </Grid>
      </StyledGrid>
    </Grid>
  );
};

export default FaqItem;
